window.Vue = require('vue');

export class StockService {

    constructor() {
        this._productStock = {};
        this._productSkuStock = {};
    }

    getStock(productId) {

        let result = null;
        if (typeof this._productStock[productId] === 'undefined') {
            this.loadStock(productId);
            result = this._productStock[productId];
        }

        return result;
    }

    getStockBySku(productSku) {

        let result = null;
        if (typeof this._productSkuStock[productSku] === 'undefined') {
            this.loadStockBySku(productSku);
            result = this._productSkuStock[productSku];
        }

        return result;
    }

    setStock(productId, stock) {
        this._productStock[productId] = stock;
        bus.$emit('product-stock-component:added', productId, stock);
    }

    loadStock(productId) {
        bus.$emit('product-stock-component:loading', productId);
        axios.get('/api/products/' + productId + '/stock')
            .then(response => {
                bus.$emit('product-stock-component:loaded', productId, response.data[0]);
                this.setStock(productId, response.data[0]);
            });
    }

    loadStockBySku(productSku) {
        bus.$emit('product-stock-component:loading', productSku);
        axios.get('/api/products/' + productSku + '/stock-by-sku')
            .then(response => {
                bus.$emit('product-stock-component:loaded', productSku, response.data[0]);
                this.setStock(productSku, response.data[0]);
            });
    }
}
